import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import { CreateTableNew as CreateTable } from "../../../../common/APICommon";
import { LoadingSpinner } from "../../../../common/Loading";

export const CrewDetailModal = ({ isOpen, onClose, vessel, crew, loading }) => {
  const [currentPage, setCurrentPage] = useState(1);

  if (!isOpen || !vessel) return null;


  const headers = ["Vessel", "Vessel Type", "Employee ID", "Full Name", "Title Code", "Book Number"];
  const accessors = ["vesselName", "vesselType", "employeeId", "fullName", "titleCode", "bookNumber"];

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-4 overflow-auto">
      <div className="bg-white w-full max-w-5xl rounded-xl shadow-2xl flex flex-col max-h-[90vh]">

        {/* Header */}
        <div className="flex justify-between items-center px-6 py-3 border-b bg-gray-50 rounded-t-xl">
          <div className="flex items-center gap-3">
            <DirectionsBoatIcon className="text-blue-900" fontSize="small" />
            <div>
              <h2 className="text-sm font-bold text-blue-900 uppercase tracking-wide">
                {vessel.vesselName}
              </h2>
              <p className="text-[11px] text-gray-400">
                Destination Head:{" "}
                <span className="font-semibold text-gray-600">{vessel.destinationHeadName}</span>
                &nbsp;·&nbsp; Onboard Crew:{" "}
                <span className="font-semibold text-gray-600">{vessel.crewCount}</span>
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-md bg-transparent border-none cursor-pointer transition-colors"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto flex-grow p-4">
          <CreateTable
            tableName="CrewDetailTable"
            headers={headers}
            accessors={accessors}
            data={crew}
            actions={[]}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={10}
            totalItems={crew?.length}
          />
        </div>

        {/* Footer */}
        <div className="px-6 py-3 border-t bg-gray-50 flex justify-end rounded-b-xl">
          <button
            onClick={onClose}
            className="px-5 py-1.5 bg-slate-600 text-white rounded-lg cursor-pointer hover:bg-slate-700 border-none transition-colors text-xs font-semibold uppercase tracking-wide"
          >
            Close
          </button>
        </div>

      </div>
      <LoadingSpinner loading={loading} />
    </div>
  );
};